/**
 * Biểu tượng nét mảnh (24×24) cho từng công cụ, dùng ở /cong-cu (thẻ và banner).
 * Công cụ mới chưa có biểu tượng sẽ dùng hình lưới mặc định, không vỡ trang.
 */
const HINH = {
  // Điểm sẵn sàng: đồng hồ đo
  "diem-san-sang-goi-von": <><path d="M4 16a8 8 0 1 1 16 0" /><path d="M12 16l4-5" /><circle cx="12" cy="16" r="1.2" /></>,
  // Runway: đồng hồ cát
  "tinh-runway": <><path d="M7 3h10M7 21h10" /><path d="M8 3c0 5 8 5 8 9s-8 4-8 9M16 3c0 5-8 5-8 9s8 4 8 9" /></>,
  // Gọi bao nhiêu: chồng xu
  "goi-bao-nhieu": <><ellipse cx="12" cy="6" rx="6" ry="2.5" /><path d="M6 6v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5V6" /><path d="M6 10v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-4" /><path d="M6 14v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-4" /></>,
  // Kinh tế đơn vị: khối hộp
  "kiem-tra-gia-dinh-kinh-te-don-vi": <><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" /><path d="M4 7.5l8 4.5 8-4.5M12 12v9" /></>,
  // Chỉ số tăng trưởng: đường đi lên
  "chi-so-tang-truong": <><path d="M3 17l6-6 4 4 8-8" /><path d="M15 7h6v6" /></>,
  // Chia cổ phần sáng lập: hai người
  "chia-co-phan-dong-sang-lap": <><circle cx="8" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" /><path d="M2.5 20c0-3.3 2.5-6 5.5-6s5.5 2.7 5.5 6" /><path d="M14 14.5c.9-.6 1.9-1 3-1 2.5 0 4.5 2.3 4.5 5.5" /></>,
  // Bảng cổ phần: biểu đồ tròn
  "bang-co-phan-va-pha-loang": <><path d="M12 3a9 9 0 1 0 9 9h-9z" /><path d="M15 3.5A9 9 0 0 1 20.5 9H15z" /></>,
  // Mô phỏng vòng: thanh trượt
  "mo-phong-vong-goi-von": <><path d="M4 7h16M4 17h16" /><circle cx="9" cy="7" r="2.2" /><circle cx="15" cy="17" r="2.2" /></>,
  // SAFE: tờ giấy có mũi tên chuyển đổi
  "safe-va-trai-phieu-chuyen-doi": <><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /><path d="M9 14h6M13 12l2 2-2 2" /></>,
  // Định giá pre-seed: nhãn giá
  "dinh-gia-pre-seed": <><path d="M3 12V4h8l10 10-8 8z" /><circle cx="7.5" cy="8.5" r="1.5" /></>,
  // Định giá có doanh thu: viên kim cương
  "dinh-gia-co-doanh-thu": <><path d="M6 3h12l3 6-9 12L3 9z" /><path d="M3 9h18M9 3l3 18 3-18" /></>,
  // Pháp lý: khiên có dấu tích
  "ho-so-phap-ly-khoi-nghiep": <><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z" /><path d="M8.5 12l2.5 2.5 4.5-5" /></>,
  // Pitch deck: màn chiếu
  "pitch-deck-10-slide": <><rect x="3" y="4" width="18" height="12" rx="1.5" /><path d="M12 16v4M8 20h8" /><path d="M7 12l3-3 2 2 4-4" /></>,
  // Quy mô thị trường: ba vòng tròn lồng nhau
  "quy-mo-thi-truong": <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="14" r="5.5" /><circle cx="12" cy="16" r="2.2" /></>,
  // Quỹ phù hợp: la bàn
  "quy-phu-hop": <><circle cx="12" cy="12" r="9" /><path d="M15.5 8.5l-2 5-5 2 2-5z" /></>,
  // Term sheet: tờ giấy có dấu tích
  "doc-term-sheet": <><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /><path d="M9 15l2 2 4-4" /></>,
};
const MAC_DINH = <><rect x="4" y="4" width="7" height="7" rx="1" /><rect x="13" y="4" width="7" height="7" rx="1" /><rect x="4" y="13" width="7" height="7" rx="1" /><rect x="13" y="13" width="7" height="7" rx="1" /></>;

export default function CongCuIcon({ slug, ...rest }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      {HINH[slug] || MAC_DINH}
    </svg>
  );
}
